import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const generatedCommissionSelector = createFeatureSelector<IState>('generatedCommission');
export const getGeneratedCommissionsSelector = createSelector(generatedCommissionSelector, (state: IState) => state); 
export const getGeneratedCommissionSelector = createSelector(generatedCommissionSelector, (state: IState) => state.selectedItem); 

